export default {
  setSelectName(state, name) {
    state.selectName = name;
  },
  setRefreshPage(state, name) {
    state.refreshPage = name;
  },
  setMenuList(state, menuList) {
    state.menuList = menuList;
  },
  setUrl(state, url) {
    state.url = url;
  }
}


// WEBPACK FOOTER //
// ./src/vuex/mutations.js